import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
export class GrowthSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        this.SegmentService = SegmentService;
    }
    setApplication(application) {
        this.application = application;
    }
    trackEvent(event, payload, success) {
        this.SegmentService.setAccount(payload);
        this.SegmentService.createApplicationTrack({
            trackEvent: event,
            application: this.application,
            payload: { ...payload, Status: this.eventStatus(success) },
        });
    }
    eventStatus(success) {
        if (success === undefined) {
            return;
        }
        return success ? SUCCESS_STATUS : FAILURE_STATUS;
    }
}
GrowthSegmentService.$inject = ['SegmentService'];
